"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInvalidateOnBlock = void 0;
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const block_1 = require("./block");
/**
 * Invalidate the given query on every new block.
 */
function useInvalidateOnBlock({ enabled, queryKey, }) {
    const queryClient = (0, react_query_1.useQueryClient)();
    const [previousHash, setPreviousHash] = (0, react_1.useState)(undefined);
    (0, block_1.useBlock)({
        refetchInterval: 5000,
        onSuccess: enabled
            ? async (block) => {
                if (block.block_hash !== previousHash) {
                    await queryClient.invalidateQueries(queryKey, { refetchType: 'all' });
                    setPreviousHash(block.block_hash);
                }
            }
            : undefined,
    });
}
exports.useInvalidateOnBlock = useInvalidateOnBlock;
//# sourceMappingURL=invalidate.js.map